module.exports = __webpack_public_path__ + "img/slot-active.b880004c.png";